import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formVisibilityMap: {},
  loading: false,
};

const formVisibilitySlice = createSlice({
  name: "formVisibility",
  initialState,
  reducers: {
    setFormVisibility: (state, action) => {
      return {
        ...state,
        formVisibilityMap: {
          ...state.formVisibilityMap,
          [action.payload.form]: action.payload.map,
        },
      };
    },
    setLoading: (state, action) => {
      return { ...state, loading: action.payload };
    },
  },
});

export const formVisibilityActions = formVisibilitySlice.actions;
export default formVisibilitySlice;
